"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_present_1 = require("../any/is-present");
class Csv {
    /*
    * Construct a Csv from the given array of objects.
    *
    * @Param {data} data           = The array of objects to use.
    * @Param {delimiter} delimiter = The delimiter to use for separating values.
    * @class
    */
    static toString(data, delimiter = ';') {
        const headers = Csv.buildHeaderRow(data);
        const rows = Csv.buildRows(data, headers, delimiter);
        return [this.join(headers, delimiter), ...rows].join('\n');
    }
    /*
    * Construct an object of type T from a csv string
    *
    * @Param {source} source           = The csv string
    * @Param {propertyMap} propertyMap = Maps properties to headers in the csv string
    * @Param {delimiter} delimiter     = The delimiter that is used for separating values.
    * @class
    */
    static fromString(source, propertyMap, delimiter = ';') {
        const newLine = /\r\n|\r|\n/;
        const rows = source.split(newLine);
        const [headerRow, ...dataRows] = rows;
        if (is_present_1.isPresent(headerRow)) {
            const headers = headerRow.split(delimiter);
            const indexedProperties = propertyMap.map((prop) => (Object.assign({ index: headers.indexOf(prop.header) }, prop)));
            return dataRows.map((row) => {
                const values = row.split(delimiter);
                const target = {};
                indexedProperties.forEach((map) => {
                    const { key, index } = map;
                    target[key] = values[index];
                });
                return target;
            });
        }
        return [];
    }
    static buildHeaderRow(data) {
        return data.reduce((acc, entry) => {
            Object.entries(entry).forEach(([key]) => {
                if (acc.includes(key))
                    return;
                acc.push(key);
            });
            return acc;
        }, []);
    }
    static buildRows(data, headers, delimiter) {
        return data.reduce((acc, entry) => {
            const row = headers.map((key) => entry[key]);
            return [...acc, Csv.join(row, delimiter)];
        }, []);
    }
    static join(row, delimiter) {
        return row.join(delimiter);
    }
}
exports.Csv = Csv;
//# sourceMappingURL=csv.js.map